import React from 'react'

const Footer = () => {
    return (
        <>
            <div className="clearfix"></div>

            <footer className="site-footer p-0">
                <div className="footer-inner bg-white p-4">
                    <div className="row">
                        <div className="col-sm-6">
                            &copy; Copyright <span id="date">2024</span> &nbsp;<a href="#" className='text-primary fw-bold'>  Skilletix  </a>&nbsp; All
                            Rights Reserved.
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default Footer
